import { createContext, useContext, useEffect, useState } from 'react';
import { getAllTableData } from '../services/transactionHistory';
import { DateFormats, formatDate } from '../utils/utils';
import { AuthStore } from './auth';

const date = new Date();

export type TransactionHistoryState = {
  transactionHistory: [];
};

export const TransactionHistoryStore = createContext<TransactionHistoryState>({
  transactionHistory: [],
});

const { Provider } = TransactionHistoryStore;

export const TransactionHistoryProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [transactionHistoryState, setTransactionHistoryState] =
    useState<TransactionHistoryState>({
      transactionHistory: [],
    });

  useEffect(() => {
    let count = 0;
    let transactionHistory = getAllTableData(selectedPersona).map((x: any) => {
      count += 5;

      return {
        ...x,
        requestedDate: formatDate(
          new Date(date.getFullYear(), date.getMonth(), date.getDate() - count),
          DateFormats.US
        ),
      };
    });

    setTransactionHistoryState({
      transactionHistory,
    });
  }, [selectedPersona]);

  return <Provider value={transactionHistoryState}>{children}</Provider>;
};
